export const DASHBOARD = {
  FETCH_DASHBOARD_DATA: 'FETCH_DASHBOARD_DATA',
  ANIMATE_COUNTER: 'ANIMATE_COUNTER',
  UPDATE_OPPORTUNITIES: 'UPDATE_OPPORTUNITIES',
  FETCH_MEMBER_DATA: 'FETCH_MEMBER_DATA',
  START_MEMBER_FETCH: 'START_MEMBER_FETCH',
  END_MEMBER_FETCH: 'END_MEMBER_FETCH'
};

export const EVENT_NAMES = {
  WELCOME_BONUS: 'Welcome Bonus',
  WEEKLY_UPDATE: 'Weekly Status Update',
  APPOINTMENT_OUTCOME: 'Appointment Outcome'
};
